/**
 * Utility functions for handling dates and times from the API
 * API dates are in GMT but may not include the 'Z' suffix
 */

/**
 * Parse a GMT timestamp string and return a Date object in local time
 * Handles timestamps with or without 'Z' suffix
 * @param {string} gmtTimestamp - GMT timestamp string (e.g., "2026-01-15T00:36:45.891796" or "2026-01-15T00:36:45.891796Z")
 * @returns {Date} Date object in local timezone
 */
export function parseGMTDate(gmtTimestamp) {
  if (!gmtTimestamp) return null;
  
  // If timestamp doesn't end with 'Z', add it to indicate UTC
  const timestamp = gmtTimestamp.endsWith('Z') ? gmtTimestamp : `${gmtTimestamp}Z`;
  return new Date(timestamp);
}

/**
 * Format a GMT timestamp as a localized date/time string
 * @param {string} gmtTimestamp - GMT timestamp string
 * @returns {string} Localized date/time string
 */
export function formatDateTime(gmtTimestamp) {
  const date = parseGMTDate(gmtTimestamp);
  return date ? date.toLocaleString() : '';
}

/**
 * Format a GMT timestamp as a localized date string
 * @param {string} gmtTimestamp - GMT timestamp string
 * @returns {string} Localized date string
 */
export function formatDate(gmtTimestamp) {
  const date = parseGMTDate(gmtTimestamp);
  return date ? date.toLocaleDateString() : '';
}

/**
 * Format a GMT timestamp as a localized time string
 * @param {string} gmtTimestamp - GMT timestamp string
 * @returns {string} Localized time string
 */
export function formatTime(gmtTimestamp) {
  const date = parseGMTDate(gmtTimestamp);
  return date ? date.toLocaleTimeString() : '';
}
